import type SignalTypes from "./SignalTypes";
import { copyAllProperties } from "./utils";

import Logger from "../Logger";
const logger = new Logger();

const mapDptsToBits: any = {
  "dpst-1": 1,
  "dpst-2": 2,
  "dpst-3": 4,
  "dpst-4": 8,
  "dpst-5": 8,
  "dpst-6": 8,
  "dpst-7": 16,
  "dpst-8": 16,
  "dpst-9": 16,
  "dpst-10": 24,
  "dpst-11": 24,
  "dpst-12": 32,
  "dpst-13": 32,
  "dpst-14": 32,
  "dpst-15": 32,
  "dpst-16": 112,
  "dpst-17": 8,
  "dpst-18": 8,
  "dpst-19": 64,
  "dpst-20": 8,
  "dpst-21": 8,
  "dpst-22": 16,
  "dpst-23": 2,
  "dpst-24": 312,
  "dpst-25": 8,
  "dpst-26": 8,
  "dpst-27": 32,
  "dpst-28": 312,
  "dpst-29": 64,
  "dpst-30": 24,
  "dpst-206": 24,
  "dpst-207": 16,
  "dpst-217": 16,
  "dpst-219": 48,
  "dpst-222": 48,
  "dpst-225": 24,
  "dpst-229": 48,
  "dpst-230": 64,
  "dpst-232": 24,
  "dpst-234": 16,
  "dpst-235": 48,
  "dpst-236": 8,
  "dpst-237": 16,
  "dpst-238": 8,
  "dpst-240": 24,
  "dpst-241": 32,
  "dpst-242": 48,
  "dpst-244": 16,
  "dpst-245": 48,
  "dpst-246": 16,
  "dpst-249": 48,
  "dpst-250": 24,
  "dpst-251": 48,
  "dpst-252": 40,
  "dpst-254": 24,
  "dpst-255": 64,
  "dpst-275": 64,
};
export default class SignalType {
  _name: string = "";
  _bits: number | undefined;

  static allSignalTypes = new Map<string, SignalType>();

  get name(): string {
    return this._name;
  }

  description = { en: "", de: undefined };
  isActorSignal = true;
  isStatus = false;
  isIgnored = false;
  dpts: Array<string> | undefined;
  dpa?: string;

  globalGroupAdress: string | undefined;

  equals(other: SignalType) {
    return this.name == other.name;
  }

  equalsExtended(other: SignalType) {
    return this.name.split(".")[0] == other.name.split(".")[0];
  }

  constructor(data?: any) {
    // we do not want to allow setting the name other than via the constructor.
    // this conflicts with copyAllProperties, thus we set it manually and delte it from
    // the provided data
    this._name = data.name;
    delete data.name;
    copyAllProperties(data, this);
    SignalType.allSignalTypes.set(this.name, this);
  }

  toString() {
    return this.description.en;
  }

  toJSON() {
    return { name: this.name };
  }

  fromJSON(data: any): SignalType {
    const res = (window as any).getSignalTypeByName(data.name) as SignalType;
    if (!res) {
      logger.error("signalType not found: ", data.name);
    }
    return res;
  }

  //
  // All Bitsizes of all Dpst allowed for this signal
  //
  get bitsizes(): Set<number> {
    return SignalType.getBitsizesFromDpsts(this.dpts || []);
  }

  static getBitsizesFromDpsts(dpsts: Array<string>): Set<number> {
    let res = new Set<number>();

    dpsts?.forEach((dpst) => {
      const bits = SignalType.getBitsizeOfDpts(dpst);
      if (bits > 0) {
        res.add(bits);
      }
    });
    return res;
  }

  static getBitsizeOfDpts(dpts: string): number {
    const index = dpts.indexOf("-");
    if (index >= 0) {
      let index2 = dpts.indexOf("-", index + 1);
      if (index2 < 0) {
        index2 = dpts.length;
      }
      const firstPart = dpts.substring(0, index2);

      const bits = mapDptsToBits[firstPart];
      if (bits) {
        return bits;
      }
    }
    return -1;
  }
}
